import { computed, inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { Auth } from '@core/services';
import { UserRole } from '@core/interfaces/role.interface';

export const adminGuard: CanActivateFn = () => {
  const authService = inject(Auth);

  const user = computed(() => authService.user || {});
  const isAdmin = computed(() => user().role?.name === UserRole.ADMIN);

  if (!isAdmin()) {
    authService.logout();
    return false;
  }

  return true;
};
